// Vendor libraries
import { EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { takeWhile } from 'rxjs/operators';
// Constants / utils
import { DELETE_HIDDEN_REPORT_TYPES, REPORT_TYPE_LEGACY_TEARSHEETS, REPORT_TYPE_LEGACY_Y_RATING, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/constants';
import { memoizeOne } from 'NewAngular/utils/memoize-one';
// Services
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { CustomPDFReportService } from 'CustomPDFReportsApp/ts/services/custom-pdf-report.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
// Actions
import { deleteReport, fetchReportMenu, setCurrentReportIndex, setCurrentReportTypeIndex, setReportMenuFetchFailure, setReportMenuFetchSuccess, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/report-menu/report-menu.actions';
import { resetSelectedReport, setSelectedReport, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/selected-report/selected-report.actions';
import { resetAllCustomPdfReportItems } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/actions';
import { incrementCurrentWizardStep } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/wizard-step/wizard-step.actions';
// Reducers
import { CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/reducer';
// Selectors
import { getCurrentReportIndex, getCurrentReportTypeIndex, getCurrentReportTypeName, getCurrentWizardStepIndex, getCustomPdfReportMenu, getMenuLoadingStatus, getPrimarySecurity, getReportMenuFetchRequest, getReportsForReportType, getSelectedReport, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/selectors';
// Components
import { ConfirmModalComponent } from 'NewAngular/features/components/modals/confirm-modal/confirm-modal.component';
import { PreviewImageModalComponent } from 'NewAngular/features/components/modals/preview-image-modal/preview-image-modal.component';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "CustomPDFReportsApp/ts/services/custom-pdf-report.service";
import * as i3 from "NewAngular/services/core/urls.service";
import * as i4 from "@ngrx/store";
import * as i5 from "@angular/common";
import * as i6 from "../../../../../../../../../ycharts/static/ts/features/components/modals/confirm-modal/confirm-modal.component";
import * as i7 from "@angular/forms";
import * as i8 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i9 from "../../../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
import * as i10 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i11 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-footer.component";
import * as i12 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
import * as i13 from "../../../../../../../../../ycharts/static/ts/features/components/modals/preview-image-modal/preview-image-modal.component";
import * as i14 from "../../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
const _c0 = ["confirmDeleteModal"];
const _c1 = a0 => ({ active: a0 });
function CustomPdfReportModalComponent_ycn_loading_symbol_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol", 6);
} if (rf & 2) {
    i0.ɵɵproperty("loaderMessage", "Loading...");
} }
function CustomPdfReportModalComponent_div_3_li_6_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 20);
    i0.ɵɵlistener("click", function CustomPdfReportModalComponent_div_3_li_6_Template_li_click_0_listener() { const $index_r4 = i0.ɵɵrestoreView(_r3).index; const ctx_r4 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r4.updateReportTypeIndex($index_r4)); });
    i0.ɵɵelementStart(1, "a", 21);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const reportType_r6 = ctx.$implicit;
    const $index_r4 = ctx.index;
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(i0.ɵɵpureFunction1(3, _c1, ctx_r4.currentReportTypeIndex === $index_r4));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(reportType_r6.name);
} }
function CustomPdfReportModalComponent_div_3_div_11_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵlistener("click", function CustomPdfReportModalComponent_div_3_div_11_div_5_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r9); const report_r10 = i0.ɵɵnextContext().$implicit; const ctx_r4 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r4.previewImageHandler(report_r10.preview_image_url)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-preview");
} }
function CustomPdfReportModalComponent_div_3_div_11_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵlistener("click", function CustomPdfReportModalComponent_div_3_div_11_div_6_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r11); const ctx_r4 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r4.deleteHandler()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("tooltipTitle", "Delete");
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-delete");
} }
function CustomPdfReportModalComponent_div_3_div_11_p_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 38);
} if (rf & 2) {
    const report_r10 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("textContent", "Owned by " + (report_r10.sharing == null ? null : report_r10.sharing.owner_name));
} }
function CustomPdfReportModalComponent_div_3_div_11_span_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 39);
    i0.ɵɵtext(1, "No description");
    i0.ɵɵelementEnd();
} }
function CustomPdfReportModalComponent_div_3_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22)(1, "label", 23)(2, "input", 24);
    i0.ɵɵlistener("ngModelChange", function CustomPdfReportModalComponent_div_3_div_11_Template_input_ngModelChange_2_listener() { const $index_r8 = i0.ɵɵrestoreView(_r7).index; const ctx_r4 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r4.updateCurrentReport($index_r8)); });
    i0.ɵɵtwoWayListener("ngModelChange", function CustomPdfReportModalComponent_div_3_div_11_Template_input_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r4 = i0.ɵɵnextContext(2); i0.ɵɵtwoWayBindingSet(ctx_r4.currentReportIndex, $event) || (ctx_r4.currentReportIndex = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "span", 25);
    i0.ɵɵelementStart(4, "div", 26);
    i0.ɵɵtemplate(5, CustomPdfReportModalComponent_div_3_div_11_div_5_Template, 2, 1, "div", 27)(6, CustomPdfReportModalComponent_div_3_div_11_div_6_Template, 2, 2, "div", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 29);
    i0.ɵɵelement(8, "div", 30);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 31);
    i0.ɵɵtemplate(10, CustomPdfReportModalComponent_div_3_div_11_p_10_Template, 1, 1, "p", 32);
    i0.ɵɵelement(11, "hr", 33);
    i0.ɵɵtemplate(12, CustomPdfReportModalComponent_div_3_div_11_span_12_Template, 2, 0, "span", 34);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const report_r10 = ctx.$implicit;
    const $index_r8 = ctx.index;
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r4.currentReportIndex);
    i0.ɵɵproperty("value", $index_r8);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", report_r10.preview_image_url);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r4.canDeleteReport(report_r10.report_type, report_r10.sharing == null ? null : report_r10.sharing.is_owner));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", report_r10.report_name);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", report_r10.sharing);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !report_r10.report_description);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", report_r10.report_description, " ");
} }
function CustomPdfReportModalComponent_div_3_p_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 40);
    i0.ɵɵtext(1, " To change the timeframe and to hide or display the benchmark in the Level Chart, update selections on the security's Quote tab before generating your Tearsheet. ");
    i0.ɵɵelementEnd();
} }
function CustomPdfReportModalComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "div", 7)(2, "div", 8)(3, "div", 9)(4, "div", 10)(5, "ul", 11);
    i0.ɵɵtemplate(6, CustomPdfReportModalComponent_div_3_li_6_Template, 3, 5, "li", 12);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 13)(8, "div", 14)(9, "div", 15)(10, "div", 16);
    i0.ɵɵtemplate(11, CustomPdfReportModalComponent_div_3_div_11_Template, 14, 8, "div", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, CustomPdfReportModalComponent_div_3_p_12_Template, 2, 0, "p", 18);
    i0.ɵɵelementEnd()()()()();
    i0.ɵɵelementStart(13, "ycn-simple-modal-footer", 19);
    i0.ɵɵlistener("cancelHandler", function CustomPdfReportModalComponent_div_3_Template_ycn_simple_modal_footer_cancelHandler_13_listener() { i0.ɵɵrestoreView(_r2); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.exitModalHandler()); })("submitHandler", function CustomPdfReportModalComponent_div_3_Template_ycn_simple_modal_footer_submitHandler_13_listener() { i0.ɵɵrestoreView(_r2); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.forward()); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngForOf", ctx_r4.customPdfReportMenu);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", ctx_r4.currentTypeReports)("ngForTrackBy", ctx_r4.trackById);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r4.currentReportTypeInternalName === ctx_r4.tearsheetsInternalName);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cancelButtonText", "Reset")("errorText", ctx_r4.errorText)("submitButtonText", ctx_r4.submitButtonText)("disableSubmission", ctx_r4.currentReportIndex === null);
} }
/**
 * Custom PDF Report Modal Component
 *
 * This component displays the menu of Custom PDF Reports organized by report type.
 * It is typically the first modal displayed in the Custom PDF Report generation process.
 *
 * Output Properties:
 *  broadcastWizardStepEvent: emits when moving to the next wizard step in the report generation process.
 *
 */
export class CustomPdfReportModalComponent {
    constructor(ajaxService, customPdfService, urlsService, store) {
        this.ajaxService = ajaxService;
        this.customPdfService = customPdfService;
        this.urlsService = urlsService;
        this.store = store;
        this.broadcastWizardStepEvent = new EventEmitter();
        this.currentReportIndex = null;
        this.securityId = '';
        this.isLoading = true;
        this.modalOpen = false;
        this.currentTypeReports = [];
        this.currentReportTypeInternalName = '';
        this.tearsheetsInternalName = REPORT_TYPE_LEGACY_TEARSHEETS;
        this.customPdfReportMenu = [];
        this.submitButtonText = 'Start';
        this.onePageReportTypes = new Set([REPORT_TYPE_LEGACY_TEARSHEETS, REPORT_TYPE_LEGACY_Y_RATING]);
        this.fetchRequest = { fetching: false, error: null, status: null };
        this.reportMenuFetchSubscription = null;
        this.isAlive = true;
        this.mapStateToComponent = (state) => {
            const { securityId } = getPrimarySecurity(state);
            this.securityId = securityId ?? '';
            const selectedReport = getSelectedReport(state);
            if (state.primarySecurity.securityId &&
                !Object.keys(selectedReport).length &&
                !this.modalOpen &&
                getCurrentWizardStepIndex(state) === 0) {
                this.fetchReportMenu();
                this.openModal();
            }
            this.customPdfReportMenu = getCustomPdfReportMenu(state);
            this.fetchRequest = getReportMenuFetchRequest(state);
            this.isLoading = getMenuLoadingStatus(state);
            this.selectedReport = selectedReport;
            this.currentReportTypeIndex = getCurrentReportTypeIndex(state);
            this.currentReportIndex = getCurrentReportIndex(state);
            this.currentTypeReports = getReportsForReportType(state);
            this.currentReportTypeInternalName = getCurrentReportTypeName(state);
            this.submitButtonText = this.onePageReportTypes.has(this.currentReportTypeInternalName) ? 'Generate' : 'Start';
        };
        this.canDeleteReport = memoizeOne((reportType, is_owner) => {
            return !DELETE_HIDDEN_REPORT_TYPES.includes(reportType) && is_owner;
        });
        this.storeSubscription = this.store
            .select(CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY)
            .pipe(takeWhile(() => this.isAlive))
            .subscribe(this.mapStateToComponent);
    }
    ngOnDestroy() {
        this.isAlive = false;
    }
    fetchReportMenu() {
        if (this.reportMenuFetchSubscription !== null) {
            this.reportMenuFetchSubscription.unsubscribe();
        }
        this.store.dispatch(fetchReportMenu());
        this.reportMenuFetchSubscription = this.customPdfService
            .getPDFReports(this.securityId)
            .pipe(takeWhile(() => this.isAlive))
            .subscribe({
            next: (res) => {
                const data = res.filter((reportType) => reportType.reports?.length > 0);
                this.store.dispatch(setReportMenuFetchSuccess({ data }));
            },
            error: () => {
                this.errorText = 'Unable to fetch reports; please refresh the page or contact support.';
                this.store.dispatch(setReportMenuFetchFailure({ error: this.errorText }));
            },
        });
    }
    updateReportTypeIndex(index) {
        this.store.dispatch(setCurrentReportTypeIndex({ index }));
        this.store.dispatch(setCurrentReportIndex({ index: null }));
    }
    updateCurrentReport(index) {
        this.store.dispatch(setCurrentReportIndex({ index }));
        if (index < this.currentTypeReports.length) {
            const reportObject = this.currentTypeReports[index];
            this.store.dispatch(setSelectedReport({ reportData: reportObject }));
        }
    }
    openModal() {
        this.modalOpen = true;
        // If report is not selected, reset indexes so a check mark is not displayed
        if (!this.isReportSelected()) {
            this.store.dispatch(setCurrentReportTypeIndex({ index: this.currentReportTypeIndex }));
            this.store.dispatch(setCurrentReportIndex({ index: null }));
        }
    }
    closeModal() {
        this.modalOpen = false;
        this.errorText = undefined;
    }
    exitModalHandler() {
        this.store.dispatch(resetAllCustomPdfReportItems());
        this.closeModal();
    }
    previewImageHandler(previewImageURL) {
        if (this.previewImageModalComponent) {
            this.previewImageModalComponent.openModal(previewImageURL);
        }
    }
    isReportSelected() {
        return this.selectedReport !== null && this.selectedReport !== undefined;
    }
    forward() {
        if (this.isReportSelected()) {
            this.closeModal();
            this.store.dispatch(incrementCurrentWizardStep());
            this.broadcastWizardStepEvent.emit();
        }
    }
    deleteHandler() {
        this.confirmDeleteModal.openModal();
    }
    confirmDeleteHandler(confirmed) {
        if (confirmed) {
            const { report_id, report_type } = this.selectedReport;
            this.customPdfService.deletePDFReport(report_id).subscribe({
                next: () => {
                    this.store.dispatch(deleteReport({ reportId: report_id, reportType: report_type }));
                    this.store.dispatch(setCurrentReportIndex({ index: null }));
                    this.store.dispatch(resetSelectedReport());
                },
                error: () => {
                    this.errorText = 'Unable to delete report. Please try again or contact support.';
                },
            });
        }
    }
    trackById(index, report) {
        return report.report_id;
    }
}
CustomPdfReportModalComponent.ɵfac = function CustomPdfReportModalComponent_Factory(t) { return new (t || CustomPdfReportModalComponent)(i0.ɵɵdirectiveInject(i1.AjaxService), i0.ɵɵdirectiveInject(i2.CustomPDFReportService), i0.ɵɵdirectiveInject(i3.UrlsService), i0.ɵɵdirectiveInject(i4.Store)); };
CustomPdfReportModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CustomPdfReportModalComponent, selectors: [["ycn-custom-pdf-report-modal"]], viewQuery: function CustomPdfReportModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(PreviewImageModalComponent, 5);
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.previewImageModalComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.confirmDeleteModal = _t.first);
    } }, outputs: { broadcastWizardStepEvent: "broadcastWizardStepEvent" }, decls: 7, vars: 8, consts: [["confirmDeleteModal", ""], [3, "closeModalHandler", "open", "extraModalClasses"], [3, "closeModalHandler", "header"], [3, "loaderMessage", 4, "ngIf"], [4, "ngIf"], [3, "confirmHandler", "confirmButtonText", "confirmHeader", "confirmText"], [3, "loaderMessage"], [1, "modal-content"], [1, "modal-body"], [1, "tabs-vertical-wrap", "ng-scope"], [1, "tabs", "tabs-vertical"], [1, "nav", "nav-tabs"], ["class", "nav-item", 3, "click", 4, "ngFor", "ngForOf"], [1, "tab-content"], [1, "tab-pane", "active", "overflow-shadow"], [1, "tab-pane-inner", "overflow-shadow-inner"], [1, "report-modules"], ["class", "report-module-container", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["class", "footnote", 4, "ngIf"], [3, "cancelHandler", "submitHandler", "cancelButtonText", "errorText", "submitButtonText", "disableSubmission"], [1, "nav-item", 3, "click"], [1, "nav-link", 2, "cursor", "pointer"], [1, "report-module-container"], [1, "template-module", "custom-control", "custom-radio"], ["type", "radio", 1, "custom-control-input", 3, "ngModelChange", "ngModel", "value"], [1, "custom-control-indicator"], [1, "template-module-controls"], ["class", "btn btn-circle btn-transparent btn-preview", 3, "click", 4, "ngIf"], ["class", "btn btn-circle btn-transparent btn-delete", "ycnTooltip", "", 3, "tooltipTitle", "click", 4, "ngIf"], [1, "template-module-header", "user-select-none"], [1, "template-module-title", 3, "textContent"], [1, "template-module-body", "user-select-none"], [3, "textContent", 4, "ngIf"], [1, "hr"], ["class", "text-gray-60", 4, "ngIf"], [1, "btn", "btn-circle", "btn-transparent", "btn-preview", 3, "click"], ["ycnIcon", "", 3, "name"], ["ycnTooltip", "", 1, "btn", "btn-circle", "btn-transparent", "btn-delete", 3, "click", "tooltipTitle"], [3, "textContent"], [1, "text-gray-60"], [1, "footnote"]], template: function CustomPdfReportModalComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "ycn-modal-base", 1);
        i0.ɵɵlistener("closeModalHandler", function CustomPdfReportModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeModal()); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 2);
        i0.ɵɵlistener("closeModalHandler", function CustomPdfReportModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeModal()); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(2, CustomPdfReportModalComponent_ycn_loading_symbol_2_Template, 1, 1, "ycn-loading-symbol", 3)(3, CustomPdfReportModalComponent_div_3_Template, 14, 8, "div", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(4, "ycn-preview-image-modal");
        i0.ɵɵelementStart(5, "ycn-confirm-modal", 5, 0);
        i0.ɵɵlistener("confirmHandler", function CustomPdfReportModalComponent_Template_ycn_confirm_modal_confirmHandler_5_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.confirmDeleteHandler($event)); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("open", ctx.modalOpen)("extraModalClasses", "modal-dialog modal-no-border");
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", "Generate Report");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.isLoading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.isLoading);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("confirmButtonText", "DELETE")("confirmHeader", "Delete Report")("confirmText", "Are you sure you want to delete this report?<br><br><strong>Note:</strong> Deleting this report template will remove it permanently for all future use across all asset types.");
    } }, dependencies: [i5.NgForOf, i5.NgIf, i6.ConfirmModalComponent, i7.DefaultValueAccessor, i7.RadioControlValueAccessor, i7.NgControlStatus, i7.NgModel, i8.IconDirective, i9.LoadingSymbolComponent, i10.ModalBaseComponent, i11.SimpleModalFooterComponent, i12.SimpleModalHeaderComponent, i13.PreviewImageModalComponent, i14.TooltipDirective], encapsulation: 2 });
